import { API } from '@constants';
import getLocale from './getLocale';

function redirectToIBB() {
  const { lng } = getLocale();
  const origin = sessionStorage.getItem('origin');
  let redirectUrl = `${API.IBB_REDIRECT}?language=${lng.toUpperCase()}`;

  if (origin) {
    redirectUrl += `&origin=${origin}`;
  }

  window.location.assign(redirectUrl);
}

export default {
  redirectToIBB
};
